import React from 'react'

export const Spinner = () => {
  return (
    <div className='spinner-border spinner-border-sm mr-1 text-light' role="status">
      <span className="sr-only">Loading...</span>
    </div>
  )
}
